import {
    fetchBaseQuery,
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
    BaseQueryApi,
} from '@reduxjs/toolkit/query/react';
import { getToken } from '../baseQuery/utils';
import { showLockedScreen } from '../features/auth/slices/inactivityScreenSlice';
import { i18n } from '@senderra/translations';

export const baseCustomQuery = (
    baseUrl: string | undefined
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
    const baseQuery = fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getToken();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    });

    return async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: Record<string, any>) => {
        const result = await baseQuery(args, api, extraOptions);
        if (result.error && result.error.data) {
            if (result.error.data === 'Tenant must have active status to get access to resources') {
                api.dispatch(showLockedScreen({
                    inactivityReason: i18n.t('tenant-is-inactive'),
                    showLoginButton: true,
                }));
            }
            if (result.error.data === 'User is blocked') {
                api.dispatch(showLockedScreen({
                    inactivityReason: i18n.t('account-is-locked'),
                    showLoginButton: true,
                }));
            }
            if (result.error.data === 'User does not exist') {
                api.dispatch(showLockedScreen({
                    inactivityReason: i18n.t('account-is-deleted'),
                    showLoginButton: true,
                }));
            }
        }

        return result;
    };
};
